import { useMutation, useQuery } from '@apollo/client'
import { makeStyles } from '@material-ui/core/styles'
import { useDispatch, useSelector } from 'react-redux'
import { CircularProgress, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import infoHover from 'src/assets/PolicyTile_Images/Group9.svg'
import sadImg from 'src/assets/PolicyTile_Images/Vector.svg'
import avgImg from 'src/assets/PolicyTile_Images/Vector1.svg'
import happyImg from 'src/assets/PolicyTile_Images/Vector2.svg'
import lifeToolTipImg from 'src/assets/PolicyTile_Images/flat.svg'
import accidentalToolTipImg from 'src/assets/PolicyTile_Images/Group704.svg'
import healthToolTipImg from 'src/assets/PolicyTile_Images/Group757.svg'
import ctcImg from 'src/assets/PolicyTile_Images/Group853.svg'
import infoPic from 'src/assets/PolicyTile_Images/Vector3.svg'
import arrowPic from 'src/assets/PolicyTile_Images/Vector4.svg'
import riskScoreToolTip from 'src/assets/images/Group10.svg'
import { styled } from '@mui/material/styles'
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import { COLORS } from 'src/utils/Themes/colors'
import keycloak from 'src/utils/commonMethods/keycloak'
import {
  CTC_ENTER,
  invokeAllTypesSXP,
  PORTFOLIO_List_NEW,
} from 'src/services/individualService'
import GraphQlErrors from 'src/components/common/GraphQlErrors'
import RiskScoreTour from 'src/ProductTour/RiskScoreTour'
import RiskScorePopUpTour from 'src/ProductTour/RiskScorePopUpTour'
import {
  setRiskScoreTour,
  setRiskScoreTourForInput,
  setRiskScoreTourPopup,
} from 'src/actions'
import RiskScoreInputTour from 'src/ProductTour/RiskScoreInputTour'
import { useHistory } from 'react-router-dom'
import { INSURANCE_TYPES } from 'src/utils/constants/MyPoliciesData'
import {
  DOC_TYPE_POLICY_DOCUMENT,
  INSURANCE_CATEGORY,
  POLICY_HOLDER_TYPE,
  POLICYHOLDERTYPE_SMALLCASE,
} from 'src/utils/constants/Individual'

const RiskScore = () => {
  const activeTour = useSelector((state) => state?.tourReducer?.riskScoreTour)
  const activeTourForPopUp = useSelector(
    (state) => state?.tourReducer?.riskScoreTourPopup
  )
  const activeTourForInput = useSelector(
    (state) => state?.tourReducer?.riskScoreInputTour
  )
  const classes = useStyles()
  const userInfo = useSelector((state) => state?.userInfo)
  const dispatch = useDispatch()
  const history = useHistory()

  const handleHealthinsuranceClick = (url) => {
    history.push(`/individual/dashboard/buyPolicy/${url}`)
  }

  const [open, setOpen] = React.useState(false)
  const [riskScoreDataForChart, setRiskScoreDataForChart] = useState([])
  const [totalCTC, setTotalCTC] = useState('')

  const { data, error, loading } = useQuery(
    PORTFOLIO_List_NEW(
      userInfo?.userInfo?.userData?.mobileNumber,
      userInfo?.userInfo?.userData?.policyHolderType
    ),
    {
      errorPolicy: 'all',
      fetchPolicy: 'cache-and-network',
    }
  )
  const [testCtc] = useMutation(CTC_ENTER(), {
    refetchQueries: [
      PORTFOLIO_List_NEW(
        userInfo?.userInfo?.userData?.mobileNumber,
        userInfo?.userInfo?.userData?.policyHolderType
      ),
    ],
  })
  useEffect(() => {
    if (data) {
      let list = []

      list?.push(data?.getPortfolioV2?.riskScore?.lifeInsurance?.score)
      list?.push(data?.getPortfolioV2?.riskScore?.healthInsurance?.score)
      list?.push(data?.getPortfolioV2?.riskScore?.accidentalInsurance?.score)
      setRiskScoreDataForChart(list)
    }
  }, [data])
  if (loading)
    return (
      <div className={classes.circularProgress}>
        <CircularProgress />
      </div>
    )
  if (error) return <GraphQlErrors error={error} routeValue={'back'} />
  let lifeBar1 = 3 + (riskScoreDataForChart?.[0] / 400) * 13
  let lifeBar1Remaining = 16 - lifeBar1
  lifeBar1Remaining += lifeBar1
  let healthbar1 = 17 + 3 + (riskScoreDataForChart?.[1] / 400) * 14
  let healthbar1Remaining = 34 - healthbar1
  healthbar1Remaining += healthbar1

  let accidentalbar1 = 35 + 3 + (riskScoreDataForChart?.[2] / 200) * 12
  let accidentalbar1Remaining = 50 - accidentalbar1
  accidentalbar1Remaining += accidentalbar1

  let totalScoreValue = riskScoreDataForChart?.reduce((a, b) => a + b, 0)

  const sxpBody1 = {
    state: {
      clientId:
        userInfo?.userInfo?.userData?.clientId == null
          ? userInfo?.userName
          : userInfo?.userInfo?.userData?.clientId,
      clientType: userInfo?.userInfo?.userData?.policyHolderType,
      documentType: DOC_TYPE_POLICY_DOCUMENT,
      createdBy: userInfo?.userName,
      updatedBy: userInfo?.userName,
      email: userInfo?.userInfo?.userData?.emailId,
      token: keycloak?.token,
      roles: userInfo?.userInfo?.userData?.roles,
      clientTypeUrl:
        userInfo?.userInfo?.userData?.policyHolderType ===
        POLICY_HOLDER_TYPE?.CORPORATE
          ? POLICYHOLDERTYPE_SMALLCASE?.CORPORATE
          : POLICYHOLDERTYPE_SMALLCASE?.INDIVIDUAL,
    },
    userId: userInfo?.userName,
  }

  const invokeSxpNormal = () => {
    invokeAllTypesSXP(sxpBody1, userInfo?.userName, 'add')
  }

  const invokeSxpPurchase = () => {
    invokeAllTypesSXP(sxpBody1, userInfo?.userName, 'buy')
  }

  const imgScore = () => {
    if (totalScoreValue >= 0 && totalScoreValue <= 600) {
      return sadImg
    } else if (totalScoreValue > 600 && totalScoreValue <= 800) {
      return avgImg
    } else {
      return happyImg
    }
  }

  const textColor = () => {
    if (totalScoreValue >= 0 && totalScoreValue <= 600) {
      return '#EF6060'
    } else if (totalScoreValue > 600 && totalScoreValue <= 800) {
      return '#EDA824'
    } else {
      return '#71AD42'
    }
  }

  const barColor = (value, type) => {
    if (type === INSURANCE_CATEGORY?.ACCIDENTAL) {
      if (value >= 0 && value < 100) {
        return '#EF6060'
      } else if (value >= 100 && value < 150) {
        return '#EDA824'
      } else {
        return '#71AD42'
      }
    }
    if (value >= 0 && value < 200) {
      return '#EF6060'
    } else if (value >= 200 && value < 300) {
      return '#EDA824'
    } else {
      return '#71AD42'
    }
  }

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: COLORS?.WHITE,
      color: COLORS?.GREY,
      maxWidth: 800,
      maxHeight: 500,
      fontSize: '11px',
      padding: '20px',
      boxShadow: '0px 0px 30px rgba(0, 0, 0, 0.7)',
      borderRadius: '10px',
      background: 'linear-gradient(180deg, #FFFFFF 44.41%, #C69DAA 100%)',
    },
  }))
  const HtmlTooltip1 = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(() => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: COLORS?.WHITE,
      color: COLORS?.GREY,
      // position:"absolute",
      maxWidth: 330,
      maxHeight: 450,
      fontSize: '16px',
      padding: '20px',
      boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.5)',
      borderRadius: '10px',
      background: 'white (180deg, #FFFFFF 44.41%, #C69DAA 100%)',
    },
  }))

  const handleTooltipClose = () => {
    setOpen(false)
    dispatch(setRiskScoreTourPopup(false))
  }

  const handleTooltipOpen = () => {
    if (activeTour) {
      dispatch(setRiskScoreTourPopup(true))
      dispatch(setRiskScoreTour(false))
      dispatch(setRiskScoreTourForInput(false))
    }
    setOpen(true)
  }

  function getValue(times, value, hide) {
    let val = Math.abs(value) * times
    if (hide === true) {
      if (val >= 10000000) {
        val = (val / 10000000)?.toFixed(1)
      } else if (val >= 100000) {
        val = (val / 100000)?.toFixed(1)
      }
      return val
    }
    if (val >= 10000000) {
      val = (val / 10000000)?.toFixed(0) + 'Cr'
    } else if (val >= 100000) {
      val = (val / 100000)?.toFixed(0) + 'L'
    }
    return val
  }

  const riskScoreInputTour = !data?.getPortfolioV2?.ctc

  return (
    <div className={classes.rootContainer}>
      {!riskScoreInputTour && activeTour && (
        <RiskScoreTour
          handleTooltipOpen={handleTooltipOpen}
          riskScoreInputTour={activeTourForInput}
          userId={userInfo?.userInfo?.userId}
          token={keycloak?.token}
        />
      )}
      {riskScoreInputTour && activeTourForInput && (
        <RiskScoreInputTour inputTour={riskScoreInputTour} />
      )}
      <div className={classes.root} id='riskScore'>
        <div className={classes.riskScoreContainer}>
          <p className={classes.riskScoreText}>
            Risk Score
            <HtmlTooltip1
              placement='bottom'
              title={
                <>
                  <div className={classes.riskTooltipDiv}>
                    <b className={classes.riskTooltipTitle}>
                      Risk Score Details
                    </b>
                    <div>
                      <hr className={classes.riskTooltipUnderline} />
                      <p className={classes.toolTipTyperiskdecription}>
                        The score is calculated for{' '}
                        <b className={classes.textHighlight}>
                          Life, Health, & Accident.
                        </b>
                      </p>
                      <hr className={classes.riskTooltipUnderline} />
                    </div>
                  </div>
                  <div className={classes.riskTooltipDivContent}>
                    <div className={classes.subContainerRisk}>
                      <img
                        src={riskScoreToolTip}
                        className={classes.blasttoolTipImage}
                      />
                      <div className={classes.textCenter}>
                        <p className={classes.coveringtextfont}>
                          Covering for these risks ensures leading a{' '}
                          <b className={classes.textHighlight}>
                            Risk-Free life.
                          </b>
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              }
            >
              <img
                className={classes.logoPic}
                src={infoHover}
                alt={'paisaplanLogo'}
              />
            </HtmlTooltip1>
          </p>
          <p className={classes.trovityRiskText}>
            Trovity Risk Analysis Report Score
          </p>
        </div>

        {data?.getPortfolioV2?.ctc !== undefined &&
        data?.getPortfolioV2?.ctc !== null ? (
          <ClickAwayListener
            onClickAway={() => {
              !activeTourForPopUp && handleTooltipClose()
            }}
          >
            <div>
              <HtmlTooltip
                placement='left-end'
                id='riskScorePopUp'
                interactive={true}
                onClose={handleTooltipClose}
                open={open}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                title={
                  <>
                    {open && activeTourForPopUp && <RiskScorePopUpTour />}
                    <div className={classes.helperListText}>
                      <div className={classes.toolTipItemDiv}>
                        <div>
                          <img
                            src={lifeToolTipImg}
                            className={classes.toolTipImage}
                          />
                        </div>

                        <div className={classes.tooltipButtonDiv}>
                          <p className={classes.toolTipMiddleText}>
                            If you have a Life Policy,
                          </p>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={invokeSxpNormal}
                          >
                            Upload
                          </button>
                          <span className={classes.tooltipOR}>or</span>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={() => {
                              handleHealthinsuranceClick(
                                INSURANCE_TYPES?.[3]?.redirectionUrl
                              )
                            }}
                          >
                            Purchase
                          </button>
                        </div>
                        <div className={classes.textCenter}>
                          <p className={classes.recomendationContainer}>
                            We recommend buying a protection{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              8 to 10
                            </span>{' '}
                            times your annual income.{' '}
                          </p>
                        </div>
                        <div className={classes.textCenter}>
                          <button className={classes.toolTipLastButton}>
                            For your profile having{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              {getValue(8, data?.getPortfolioV2?.ctc, true)} to{' '}
                              {getValue(10, data?.getPortfolioV2?.ctc)}
                            </span>{' '}
                            Life Insurance is recommended
                          </button>
                        </div>
                      </div>
                      <div className={classes.toolTipItemDiv}>
                        <div>
                          <img
                            src={healthToolTipImg}
                            className={classes.toolTipImage}
                          />
                        </div>

                        <div className={classes.tooltipButtonDiv}>
                          <p className={classes.toolTipMiddleText}>
                            If you have a Health Policy,
                          </p>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={invokeSxpNormal}
                          >
                            Upload
                          </button>
                          <span className={classes.tooltipOR}>or</span>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={() => {
                              handleHealthinsuranceClick(
                                INSURANCE_TYPES?.[0]?.redirectionUrl
                              )
                            }}
                          >
                            Purchase
                          </button>
                        </div>
                        <div className={classes.textCenter}>
                          <p className={classes.recomendationContainer}>
                            We recommend buying protection for{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              5 to 10
                            </span>{' '}
                            Lakhs.{' '}
                          </p>
                        </div>
                        <div className={classes.textCenter}>
                          <button className={classes.toolTipLastButton}>
                            For your profile having{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              5 to 10L
                            </span>{' '}
                            Health Insurance is recommended
                          </button>
                        </div>
                      </div>
                      <div className={classes.toolTipItemDiv}>
                        <div>
                          <img
                            src={accidentalToolTipImg}
                            className={classes.toolTipImage}
                          />
                        </div>

                        <div className={classes.tooltipButtonDiv}>
                          <p className={classes.toolTipMiddleText}>
                            If you have a Accidental Policy,
                          </p>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={invokeSxpNormal}
                          >
                            Upload
                          </button>
                          <span className={classes.tooltipOR}>or</span>
                          <button
                            className={classes.toolTipUploadButton}
                            onClick={invokeSxpPurchase}
                          >
                            Purchase
                          </button>
                        </div>
                        <div className={classes.textCenter}>
                          <p className={classes.recomendationContainer}>
                            We recommend buying a protection{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              8 to 10
                            </span>{' '}
                            times your annual income.{' '}
                          </p>
                        </div>
                        <div className={classes.textCenter}>
                          <button className={classes.toolTipLastButton}>
                            For your profile having{' '}
                            <span className={classes.tooltipRecommendedValue}>
                              {getValue(8, data?.getPortfolioV2?.ctc, true)} to{' '}
                              {getValue(10, data?.getPortfolioV2?.ctc)}
                            </span>{' '}
                            Accidental Insurance is recommended
                          </button>
                        </div>
                      </div>
                    </div>
                  </>
                }
              >
                <div
                  id='overAllSuggestions'
                  className={classes.riskScoreGraphicContainer}
                  onClick={handleTooltipOpen}
                >
                  <div className={classes.outerDiv}>
                    {/* <h1>hi</h1> */}
                    <div
                      id='riskScoreGraphicalPic'
                      className='pie animate'
                      style={{
                        '--p': `${lifeBar1}`,
                        '--c': `${barColor(riskScoreDataForChart[0])}`,
                        '--b': '10px',
                        zIndex: '10',
                        // top: "80px",
                        position: 'relative',
                        cursor: 'pointer',
                      }}
                    >
                      {' '}
                      <div id='life1' className={classes.lifeTextDiv}>
                        <p
                          className={`${classes.typeText} ${classes.lifeAlignment}`}
                        >
                          Life
                        </p>
                        <span id='life2' className={classes.typeValue}>
                          {Math.ceil(riskScoreDataForChart?.[0])}/400
                        </span>
                      </div>
                      <div className={classes.animationDiv}></div>
                    </div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': `${lifeBar1Remaining}`,
                        '--c': '#D9D9D9',
                        '--b': '10px',
                        zIndex: '9',
                        // top: "80px",
                      }}
                    ></div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': '17',
                        '--c': 'white',
                        '--b': '10px',
                        zIndex: '8',
                        // top: "80px",
                      }}
                    ></div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': `${healthbar1}`,
                        '--c': `${barColor(riskScoreDataForChart?.[1])}`,
                        '--b': '10px',
                        zIndex: '7',
                        // top: "80px",
                      }}
                    >
                      {' '}
                      <div className={classes.healthTextDiv}>
                        <p className={classes.typeText}>Health</p>
                        <span className={classes.typeValue}>
                          {Math.ceil(riskScoreDataForChart?.[1])}/400
                        </span>
                      </div>
                      <div className={classes.healthAnimationDiv}></div>
                    </div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': `${healthbar1Remaining}`,
                        '--c': '#D9D9D9',
                        '--b': '10px',
                        zIndex: '6',
                        // top: "80px",
                      }}
                    ></div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': '35',
                        '--c': 'white',
                        '--b': '10px',
                        zIndex: '5',
                        // top: "80px",
                      }}
                    >
                      {' '}
                    </div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': `${accidentalbar1}`,
                        '--c': `${barColor(
                          riskScoreDataForChart?.[2],
                          'accidental'
                        )}`,
                        '--b': '10px',
                        zIndex: '4',
                        // top: "80px",
                      }}
                    >
                      {' '}
                      <div className={classes.accidentaltextDiv}>
                        <p className={classes.typeText}>Accidental</p>
                        <span
                          className={`${classes.typeValue} ${classes.accidentalContainer}`}
                        >
                          {Math.ceil(riskScoreDataForChart?.[2])}/200
                        </span>
                      </div>
                      <div className={classes.accidentalAnimationPie}></div>
                    </div>
                    <div
                      className='pie animate'
                      style={{
                        '--p': `${accidentalbar1Remaining}`,
                        '--c': '#D9D9D9',
                        '--b': '10px',
                        zIndex: '3',
                      }}
                    >
                      {' '}
                    </div>
                    <div className={classes.numberMainContainer}>
                      <div className={classes.imageContainer}>
                        <img src={imgScore()} width='25px' />
                      </div>
                      <div className={classes.overallScoreContainer}>
                        <p className={classes.overallText}>Overall Score</p>
                        <p className={classes.scoreContainer}>
                          <span
                            style={{
                              fontSize: '14px',
                              color: `${textColor()}`,
                            }}
                          >
                            {Math.ceil(
                              parseFloat(Number(totalScoreValue)?.toFixed(2))
                            )}
                            {'/'}
                          </span>
                          <span className={classes.scoreDigit}>1000</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </HtmlTooltip>
            </div>
          </ClickAwayListener>
        ) : (
          <div className={classes.earningContainer}>
            <img src={ctcImg} />
            <p className={classes.earningText}>Your Earning Per Annum</p>
            <div className={classes.subContainer}>
              <img src={infoPic} className={classes.earningTextContainer} />
              <p className={classes.exarningTextWrap}>
                It helps in assessing your risks more accurately.
              </p>
            </div>
            <div id='totalCtcTextField' className={classes.totalCtcTextfield}>
              <div className={classes.ctcFieldContainer}>
                <TextField
                  placeholder='Rs.'
                  disabled
                  className={classes.customTextField}
                />
              </div>
              <div className={classes.enterValue}>
                <TextField
                  name='totalCTC'
                  type='totalCTC'
                  placeholder='ex - 10,00,000'
                  value={totalCTC}
                  onChange={(e) => setTotalCTC(e?.target?.value)}
                  className={classes.customTextField}
                />
              </div>
              <button
                // id='ctcButton'
                className={classes.ctcButton}
                disabled={totalCTC === ''}
                onClick={() => {
                  dispatch(setRiskScoreTourForInput(false))
                  testCtc({
                    variables: {
                      userName: userInfo?.userInfo?.userData?.userName,
                      ctc: totalCTC,
                    },
                  })
                }}
              >
                <img src={arrowPic} className={classes.arroeImg} />
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}
export default RiskScore

const useStyles = makeStyles({
  rootContainer: {
    // padding: '10px',
  },
  root: {
    backgroundColor: COLORS.WHITE,
    width: '100% !important',
    overflowY: 'hidden',
    overflowX: 'hidden',
    position: 'relative',
    borderRadius: '10px',
  },
  totalCtcTextfield: {
    display: 'flex',
    justifyContent: 'center',
    padding: '5px 0px',
    paddingBottom: '30px',
  },
  circularProgress: {
    margin: 'auto',
    position: 'absolute',
    left: '50%',
    top: '50%',
  },
  imageContainer: {
    paddingBottom: '2px',
  },
  ctcFieldContainer: {
    width: '11%',
  },
  arroeImg: {
    marginTop: '3px',
  },
  helperListText: {
    fontSize: '12px',
    display: 'flex',
    color: COLORS.BLACK,
    '& > span': {
      display: 'flex',
      marginBottom: '10px',
      '& > svg': {
        flexBasis: '12px',
        flexShrink: 0,
        // marginRight: '14px',
        maxWidth: '12px',
      },
      '& > span': {
        lineHeight: '16px',
      },
      '&:last-child': {
        margin: 0,
      },
    },
  },
  scoreDigit: {
    fontSize: '10px',
  },
  riskScoreContainer: {
    textAlign: 'center',
  },
  scoreContainer: {
    margin: '0px 0px 0px 0px',
  },
  earningContainer: {
    textAlign: 'center',
    marginTop: '7%',
  },
  earningText: {
    margin: '5px 0px 0px 0px',
    fontWeight: 'bold',
    fontSize: '14px',
  },
  subContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  earningTextContainer: {
    paddingRight: '5px',
    width: '17px',
  },
  exarningTextWrap: {
    fontSize: '10px',
    color: 'rgba(51, 51, 51, 0.5)',
    paddingTop: '3px',
  },
  overallScoreContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  overallText: {
    fontSize: '13px',
    margin: '0px 0px',
  },
  numberMainContainer: {
    marginTop: '35px',
    position: 'absolute',
  },
  accidentalContainer: {
    textAlign: 'initial',
    fontSize: '10px !important',
    color: 'rgba(51, 51, 51, 0.6) !important',
  },
  riskScoreGraphicContainer: {
    textAlign: 'center',
    cursor: 'pointer',
  },
  animationDiv: {
    position: 'absolute',
    top: '33px',
    right: '14px',
    height: '5px',
    width: '5px',
    borderRadius: '50%',
    backgroundColor: 'white',
    zIndex: 'inherit',
  },
  accidentalAnimationPie: {
    position: 'absolute',
    top: '142px',
    right: '70px',
    height: '5px',
    width: '5px',
    borderRadius: '50%',
    backgroundColor: 'white',
    zIndex: 'inherit',
  },
  subContainerRisk: {
    display: 'flex',
    justifyContent: 'center',
  },
  recomendationContainer: {
    marginTop: '0px',
  },
  button: {
    background: COLORS.MEDIUM_ORANGE,
    color: COLORS.WHITE,
    textTransform: 'unset',
    size: 'small',
    fontSize: '12px',
    fontWeight: 'bold',
    borderRadius: '12px',
    '&:hover': {
      backgroundColor: COLORS.MEDIUM_ORANGE,
    },
    marginTop: '5%',
  },
  logoPic: {
    // marginTop: "15px",
    width: '15px',
    paddingLeft: '5px',
    // paddingBottom: "15px",
  },
  riskScoreText: {
    fontWeight: 'bold',
    // marginBottom: "0px",
    fontSize: '16px',
    color: COLORS.GREY,
    display: 'flex',
    justifyContent: 'center',
    paddingTop: '10px',
    // marginTop: "10px",
  },
  healthAnimationDiv: {
    position: 'absolute',
    top: '107px',
    right: '12px',
    height: '5px',
    width: '5px',
    borderRadius: '50%',
    backgroundColor: 'white',
    zIndex: 'inherit',
  },
  trovityRiskText: {
    marginTop: '-15px',
    fontSize: '11px',
    color: 'rgba(51, 51, 51, 0.5)',
  },
  outerDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    // marginTop: "18%",
    paddingTop: '12%',
  },
  toolTipItemDiv: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '50%',
    padding: '0px 10px',
  },
  toolTipImage: {
    width: '45px',
    height: '45px',
    paddingBottom: '10px',
  },
  toolTipTypeText: {
    fontSize: '14px',
    color: COLORS.MEDIUM_BLUE,
    marginTop: '0px',
  },
  lifeAlignment: {
    textAlign: 'end',
  },
  toolTipDescriptionText: {
    fontSize: '12px',
    color: COLORS.GREY,
    marginTop: '0px',
  },
  toolTipMiddleText: {
    color: 'rgba(51, 51, 51, 0.7)',
    fontSize: '14px',
    marginBottom: '5px',
    marginTop: '0px',
  },
  toolTipUploadButton: {
    padding: '2px 20px',
    borderRadius: '20px',
    border: '1px solid #B92250',
    backgroundColor: '#B92250',
    color: 'white',
    cursor: 'pointer',
  },
  toolTipLastButton: {
    padding: '10px 40px',
    borderRadius: '40px',
    border: '1px solid red',
    backgroundColor: 'white',
  },
  lifeTextDiv: {
    transform: 'rotate(90deg)',
    position: 'absolute',
    top: '-40px',
    right: '25px',
    display: 'flex',
    flexDirection: 'column',
  },
  healthTextDiv: {
    transform: 'rotate(90deg)',
    position: 'absolute',
    top: '60px',
    right: '-45px',
    display: 'flex',
    flexDirection: 'column',
  },
  accidentaltextDiv: {
    transform: 'rotate(90deg)',
    position: 'absolute',
    top: '165px',
    right: '15px',
    display: 'flex',
    flexDirection: 'column',
  },
  typeText: {
    marginBottom: '0px',
    fontSize: '12px',
    color: '#000000',
  },
  typeValue: {
    fontSize: '10px',
    color: 'rgba(51, 51, 51, 0.6)',
  },
  ctcButton: {
    padding: '1px 5px',
    borderRadius: '20px',
    border: '1px solid #32BEA6',
    backgroundColor: '#32BEA6',
    color: 'white',
    cursor: 'pointer',
  },
  customTextField: {
    '& input::placeholder': {
      fontSize: '12px',
    },
    '& .MuiInputBase-input': {
      padding: '0px 0px 4px 10px',
      borderBottomLeftRadius: '50px',
      borderTopLeftRadius: '50px',
      borderTop: '1px solid #BCBCBC',
      WebkitTextFillColor: '#333333 !important',
      fontWeight: 'bold',
    },
    '& .MuiInputBase-root': {
      borderBottomLeftRadius: '50px',
      borderTopLeftRadius: '50px',
    },
  },
  toolTipTyperiskdecription: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '12px',
    lineHeight: '14px',
    color: 'rgba(51, 51, 51, 0.7)',
    margin: '0px 0px',
  },
  blasttoolTipImage: {
    width: '58px',
  },
  coveringtextfont: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#4F70C2',
    margin: '0px 0px',
    width: '75%',
    textAlign: 'initial',
    paddingLeft: '15px',
  },
  tooltipRecommendedValue: {
    color: '#B92250',
    fontWeight: 'bold',
  },
  tooltipOR: {
    padding: '0px 10px',
    color: 'rgba(51, 51, 51, 0.7)',
  },
  tooltipButtonDiv: {
    textAlign: 'center',
    paddingBottom: '10px',
  },
  textCenter: {
    textAlign: 'center',
  },

  riskTooltipDiv: {
    flex: 1,
    textAlign: 'center',
  },
  riskTooltipTitle: {
    fontWeight: '700',
    fontSize: '16px',
  },
  riskTooltipUnderline: {
    width: '270px',
    marginTop: '5px',
    marginBottom: '5px',
    border: '1px solid rgba(51, 51, 51, 0.2)',
  },
  riskTooltipDivContent: {
    display: 'flex',
    flexDirection: 'column',
    padding: '20px 50px 0px 50px',
  },
  textHighlight: {
    color: '#02A9F4',
  },
  enterValue: {
    width: '50%',
    paddingRight: '10px',
    '@media (min-width:1600px)': {
      width: '40%',
    },
  },
})
